import React from 'react';
import {useNavigate, Link} from 'react-router-dom';
import ReactPaginate from 'react-paginate';
import swal from 'sweetalert';

import config from '../../inc/config'
import {isoToDate, isoToDateTime, priceFormat, slugify} from '../../inc/helper';
import { getCookie } from '../../inc/cookies';
import CreditCardTransferModal from '../../component/CreditCardTransferModal';

class CreditCardRequestsModule extends React.Component {
  constructor(props){
    super(props);

    this.state = {
      isLoading: true,

      creditCardPayments: [],
      creditcardProviders: [],
      filterPaymentStatus: '',
      filterCreditCardProviderId: '',
      filterAdvertId: '',
      filterId: '',
      filterFullName: '',
      filterPaymentStartDate: '',
      filterPaymentEndDate: '',
      filterPaymentHash: '',
      filterMemberCustomerFullName: '',
      filterCardHolderName: '',
      filterMemberId: '',
      isApproved: '',
      isTransferred: '',
      isCancelled: '',


      pageCount: 0,
      resultCount: 0,
      currentPage: 1,
      limit: 10
    }
  }

  componentDidMount() {
    this.getCreditRequests(this.state.currentPage);
    window.scrollTo(0, 0);
  }

  filteredCreditRequests(currentPage) {
    let sessionHash = getCookie('sessionHash');
    this.setState({isLoading: true})

    const query = `limit=${this.state.limit}&page=${currentPage}&filterId=${this.state.filterId}&filterFullName=${this.state.filterFullName}&filterAdvertId=${this.state.filterAdvertId}&filterPaymentStatus=${this.state.filterPaymentStatus}&filterCreditCardProviderId=${this.state.filterCreditCardProviderId}&filterPaymentStartDate=${this.state.filterPaymentStartDate}&filterPaymentEndDate=${this.state.filterPaymentEndDate}&filterPaymentHash=${this.state.filterPaymentHash}&filterMemberCustomerFullName=${this.state.filterMemberCustomerFullName}&filterCardHolderName=${this.state.filterCardHolderName}&filterMemberId=${this.state.filterMemberId}&isApproved=${this.state.isApproved}&isTransferred=${this.state.isTransferred}&isCancelled=${this.state.isCancelled}`;

    const requestOptions = {
      method: 'GET',
      headers: {'Authorization': 'Bearer ' + sessionHash}
    };

    const startIndex = 0;
    const endIndex = startIndex + this.state.limit;

    fetch(config.restApi + `creditCardPayments/tr?${query}`, requestOptions)
      .then(response => response.json())
      .then(responseData => {
        switch(responseData.status) {
          case 200:
            const currentCreditRequests = responseData.creditCardPayments.slice(startIndex, endIndex);
            this.setState({isLoading: false, creditCardPayments: currentCreditRequests, pageCount: responseData.pageCount, resultCount: responseData.resultCount, currentPage: currentPage});
          break;
          case 401:
            swal({
              dangerMode: true,
              icon: 'warning',
              title: 'Hay Aksi',
              text: responseData.message,
              buttons: 'Tamam'
            }).then(this.props.navigate('/home'))
          break;
          default:
            swal({
              dangerMode: true,
              icon: 'warning',
              title: 'Hay Aksi',
              text: responseData.message,
              buttons: 'Tamam'
            }).then(this.setState({isLoading: false}))
          break;
        }
      }, () => swal({dangerMode: true, icon: 'error', title: 'Bağlantı Hatası', text: 'Lütfen internet bağlantınızı kontrol ediniz.', buttons: 'Tamam'}));
  }

  getCreditRequests(currentPage) {
    let sessionHash = getCookie('sessionHash');

    const requestOptions = {
      method: 'GET',
      headers: {'Authorization': 'Bearer ' + sessionHash}
    };

    this.setState({isLoading: true});

    let errorMessages = [];
    let remaining = 2;
    let complete = () => {
      remaining--;
      if (remaining == 0) {
        this.setState({isLoading: false});
        if (errorMessages.length > 0) {
          swal({dangerMode: true, icon: 'warning', title: 'Hay Aksi', text: errorMessages[0], buttons: 'Tamam'}).then(this.props.navigate('/home'));
        }else{
          this.setState({isLoading: false});
        }
      }
    }

    const startIndex = 0;
    const endIndex = startIndex + this.state.limit;

    fetch(config.restApi + `creditCardPayments/tr?limit=${this.state.limit}&page=${currentPage}`, requestOptions)
    .then(response => response.json())
    .then(responseData => {
      switch(responseData.status) {
        case 200: {
          const currentCreditRequests = responseData.creditCardPayments.slice(startIndex, endIndex);
          this.setState({isLoading: false, creditCardPayments: currentCreditRequests, pageCount: responseData.pageCount, resultCount: responseData.resultCount, currentPage: currentPage});
        }
        break;
        case 401:  {
          errorMessages.push(responseData.message);
        }
        break;
        default: {
          errorMessages.push(responseData.message);
        }
        break;
      }
      complete();
    }, () => errorMessages.push('Lütfen internet bağlantınızı kontrol ediniz.'));

    fetch(config.restApi + 'creditcardProviders/tr', requestOptions)
    .then(response => response.json())
    .then(responseData => {
      switch(responseData.status) {
        case 200: {
          this.setState({creditcardProviders: responseData.creditCardProviders});
        }
        break;
        case 401:  {
          errorMessages.push(responseData.message);
        }
        break;
        default: {
          errorMessages.push(responseData.message);
        }
        break;
      }
      complete();
    }, () => errorMessages.push('Lütfen internet bağlantınızı kontrol ediniz.'));
  }

  handlePageClick(page) {
    this.setState({currentPage: page.selected + 1}, () => this.filteredCreditRequests(this.state.currentPage))
  }

  phoneFormat(phone) {
    let parsedValue = /^(\d{3})(\d{3})(\d{2})(\d{2})$/.exec(phone);
    return parsedValue ? '(' + parsedValue[1] + ') ' + parsedValue[2] + ' ' + parsedValue[3] + ' ' + parsedValue[4] : '-';
  }

  filterOnClick = (event) => {
    const query = `filterId=${this.state.filterId}&filterFullName=${this.state.filterFullName}&filterAdvertId=${this.state.filterAdvertId}&filterPaymentStatus=${this.state.filterPaymentStatus}&filterCreditCardProviderId=${this.state.filterCreditCardProviderId}&filterPaymentStartDate=${this.state.filterPaymentStartDate}&filterPaymentEndDate=${this.state.filterPaymentEndDate}&filterPaymentHash=${this.state.filterPaymentHash}&filterMemberCustomerFullName=${this.state.filterMemberCustomerFullName}&filterCardHolderName=${this.state.filterCardHolderName}&filterMemberId=${this.state.filterMemberId}&isApproved=${this.state.isApproved}&isTransferred=${this.state.isTransferred}&isCancelled=${this.state.isCancelled}`;
    this.filteredCreditRequests(1, query)
  }

  resetOnClick = (event) => {
    this.setState({
      filterPaymentStatus: '',
      filterCreditCardProviderId: '',
      filterAdvertId: '',
      filterId: '',
      filterFullName: '',
      filterPaymentStartDate: '',
      filterPaymentEndDate: '',
      filterMemberCustomerFullName: '',
      filterPaymentHash: '',
      filterCardHolderName: '',
      filterMemberId: '',
      isApproved: '',
      isTransferred: '',
      isCancelled: '',
      currentPage: 1
    }, () => {this.setState({isLoading: true}, () => {this.filteredCreditRequests(this.state.currentPage);this.setState({isLoading: false});});});
  }

  handleKeyPress = (event, page) => {
    if (event.key === 'Enter') {
      const query = `filterId=${this.state.filterId}&filterFullName=${this.state.filterFullName}&filterAdvertId=${this.state.filterAdvertId}&filterPaymentStatus=${this.state.filterPaymentStatus}&filterCreditCardProviderId=${this.state.filterCreditCardProviderId}&filterPaymentStartDate=${this.state.filterPaymentStartDate}&filterPaymentEndDate=${this.state.filterPaymentEndDate}&filterPaymentHash=${this.state.filterPaymentHash}&filterMemberCustomerFullName=${this.state.filterMemberCustomerFullName}&filterCardHolderName=${this.state.filterCardHolderName}&filterMemberId=${this.state.filterMemberId}&isApproved=${this.state.isApproved}&isTransferred=${this.state.isTransferred}&isCancelled=${this.state.isCancelled}`;
      this.setState({isLoading: true, currentPage: 1}, () => {this.filteredCreditRequests(this.state.currentPage, query);this.setState({isLoading: false});});
    }
  }

  filterPaymentStatus = (event) => {
    this.setState({filterPaymentStatus: event.target.value});
  }

  filterProvider = (event) => {
    this.setState({filterCreditCardProviderId: event.target.value});
  }

  getCreditStatusName(paymentStatus) {
    if(paymentStatus === 1){
      return <strong className="font-bold text-warning">İşleme Alındı</strong>
    } else if(paymentStatus === 2){
      return <strong className="font-bold text-green">Başarılı</strong>
    } else if(paymentStatus === 3){
      return <strong className="font-bold text-danger">Başarısız</strong>
    }

    return '-'
  }

  render() {
    return this.state.isLoading ?
      <div className="ibox-content sk-loading position-static">
        <div className="sk-spinner sk-spinner-fading-circle">
          <div className="sk-circle1 sk-circle"></div>
          <div className="sk-circle2 sk-circle"></div>
          <div className="sk-circle3 sk-circle"></div>
          <div className="sk-circle4 sk-circle"></div>
          <div className="sk-circle5 sk-circle"></div>
          <div className="sk-circle6 sk-circle"></div>
          <div className="sk-circle7 sk-circle"></div>
          <div className="sk-circle8 sk-circle"></div>
          <div className="sk-circle9 sk-circle"></div>
          <div className="sk-circle10 sk-circle"></div>
          <div className="sk-circle11 sk-circle"></div>
          <div className="sk-circle12 sk-circle"></div>
        </div>
      </div>
      :
      <div className="row custom-container">
        <div className="col-xl-9">
          <div className="ibox">
            <div className="ibox-title">
              <h5 className="text-darkblue">Kredi Başvuruları</h5>
            </div>
            <div className="table-responsive overflow-x-auto">
              <table className="table table-striped table-bordered">
                <thead className="text-center">
                  <tr className="text-darkblue">
                    <th className="align-middle">Kredi No</th>
                    <th className="align-middle">İlan</th>
                    <th className="align-middle">Başvuru Sahibi</th>
                    <th className="align-middle">Kart Sahibi (Müşteri)</th>
                    <th className="align-middle">Sağlayıcı</th>
                    <th className="align-middle">İşlem Tutarı</th>
                    <th className="align-middle">Ödeme Tarihi</th>
                    <th className="align-middle">Sonuç</th>
                    <th className="align-middle">Detay</th>
                  </tr>
                </thead>
                <tbody className="text-center">
                {this.state.creditCardPayments.map((creditCardPaymentInfo) =>
                    <tr key={creditCardPaymentInfo.id}>
                      <td className="align-middle">
                        <Link className="text-orange text-underline-orange" to={`/creditRequestDetail?id=${creditCardPaymentInfo.id}`}><strong className="text-darkblue font-bold"><br />#{creditCardPaymentInfo.id}</strong></Link>
                        <br />
                        <strong className="text-darkblue font-bold">({creditCardPaymentInfo.paymentHash})</strong>
                      </td>
                      <td className="align-middle">
                        {creditCardPaymentInfo.photos.length > 0 ? <Link className="text-orange text-underline-orange" target='_blank' to={`https://${config.host}/ilan/${slugify(creditCardPaymentInfo.advertTitle)}-${creditCardPaymentInfo.advertId}/detay`}><img alt="İlan Görseli" className="w-md-50" style={{ height: 100, width:200, objectFit:"contain", overflow: "visible"}} src={`https://file.satisgaranti.com/${creditCardPaymentInfo.photos[0].path}`}/></Link>
                        : <Link className="text-orange text-underline-orange" to={`https://${config.host}/ilan/${slugify(creditCardPaymentInfo.advertTitle)}-${creditCardPaymentInfo.advertId}/detay`}><i className="fa fa-camera d-flex justify-content-center align-items-center" style={{height: 100, objectFit:"contain", overflow: "visible", fontSize: 48, color: '#d2d2d2' }}></i></Link>}
                        <br />
                        <Link className="text-orange text-underline-orange" to={`/pendingAdvertDetail?id=${creditCardPaymentInfo.advertId}`}><strong className="text-darkblue font-bold">İlan No: #{creditCardPaymentInfo.advertId}</strong></Link>
                        <br />{creditCardPaymentInfo.advertTitle}
                      </td>
                      <td className="align-middle">{creditCardPaymentInfo.memberFullName}<br /> #{creditCardPaymentInfo.memberId}</td>
                      <td className="align-middle" style={{minWidth: 110}}>{creditCardPaymentInfo.cardHolderName}<br />({creditCardPaymentInfo.memberCustomerFullName || "-"})</td>
                      <td className="align-middle" style={{minWidth: 100}}><b>{creditCardPaymentInfo.creditCardProviderName}</b> <br /> {(creditCardPaymentInfo.creditCardProviderId === 3 && creditCardPaymentInfo.paymentStatusId === 2) ? (creditCardPaymentInfo.locked === 0 ? <span className="text-danger">Onay Bekleniyor</span> : (creditCardPaymentInfo.transferDate === null ? <span className="text-warning">Transfer Bekleniyor</span> : <span className="text-green">{isoToDateTime(creditCardPaymentInfo.transferDate)}</span>)) : ''}</td>
                      <td className="align-middle">{priceFormat(creditCardPaymentInfo.amount)} ₺</td>
                      <td className="align-middle">{isoToDateTime(creditCardPaymentInfo.paymentDate)}</td>
                      <td className="align-middle">{creditCardPaymentInfo.paymentStatusId === 3 ? <strong className="font-bold text-danger">Başarısız</strong> : creditCardPaymentInfo.paymentStatusId !== 2 ? <strong className="font-bold text-warning">Beklemede</strong> : creditCardPaymentInfo.cancelledBy ? <strong className="font-bold text-danger">İptal Edildi</strong> : <strong className="font-bold text-green">Başarılı</strong>}</td>
                      <td className="align-middle"><Link className="btn btn-outline btn-orange text-center mb-1" to={'/creditCardPaymentDetail?id=' + creditCardPaymentInfo.id} title="Başvuru Detayları"><i className="fa fa-eye"></i></Link></td>
                    </tr>
                  )}
                {this.state.creditCardPayments.length === 0 && <tr><td className="align-middle p-3 text-darkblue" colSpan="9">Kredi Başvuru Listesi Bulunamadı !</td></tr>}
                </tbody>
              </table>
            </div>
            {this.state.creditCardPayments.length !== 0 &&
            <ReactPaginate
              previousLabel={"Geri"}
              nextLabel={"İleri"}
              breakLabel={"..."}  
              pageCount={this.state.pageCount}
              marginPagesDisplayed={1}
              onPageChange={page => this.handlePageClick(page)}
              pageRangeDisplayed={10}
              forcePage={this.state.currentPage -1}
              containerClassName={'pagination'}
              activeClassName={'activePage'}
            />
            }
          </div>
        </div>
        <div className="col-xl-3 order-first order-xl-last d-xl-none" id="accordion">
          <div className="ibox">
            <div className="ibox-content text-darkblue p-0">
              <h4 className="collapse-title">
                <a className="btn btn-link text-darkblue font-bold d-flex justify-content-between" data-toggle="collapse" href="#filterCollapse" title="Filtrele">Filtrele</a>
              </h4>
            </div>
            <div className="collapse" data-parent="#accordion" id="filterCollapse">
              <div className="ibox-content text-darkblue">
                <strong>Kredi No</strong>
                <input className="form-control form-input mb-2 mt-1" onChange={event => this.setState({filterId: event.target.value})} onKeyDown={this.handleKeyPress} placeholder="Kredi No" type="text" value={this.state.filterId}/>
                <strong>Ödeme Kodu</strong>
                <input className="form-control form-input mb-2 mt-1" onChange={event => this.setState({filterPaymentHash: event.target.value})} onKeyDown={this.handleKeyPress} placeholder="Ödeme Kodu" type="text" value={this.state.filterPaymentHash}/>
                <strong>Sağlayıcı</strong>
                <select className="form-control form-input mb-2 mt-1" onChange={this.filterProvider} onKeyDown={this.handleKeyPress} value={this.state.filterCreditCardProviderId}>
                  <option value="">Seçiniz</option>
                  <option value="">Seçiniz</option>
                  {this.state.creditcardProviders.map(provider =>
                  <option value={provider.id}>{provider.name}</option>
                  )}
                </select>
                <strong>İlan No</strong>
                <input className="form-control form-input mb-2 mt-1" onChange={event => this.setState({filterAdvertId: event.target.value})} onKeyDown={this.handleKeyPress} placeholder="İlan No" type="text" value={this.state.filterAdvertId}/>
                <strong>Kart Sahibi</strong>
                <input className="form-control form-input mb-2 mt-1" onChange={event => this.setState({filterCardHolderName: event.target.value})} onKeyDown={this.handleKeyPress} placeholder="Kart Sahibi" type="text" value={this.state.filterCardHolderName}/>
                <strong>Müşteri Adı Soyadı</strong>
                <input className="form-control form-input mb-2 mt-1" onChange={event => this.setState({filterMemberCustomerFullName: event.target.value})} onKeyDown={this.handleKeyPress} placeholder="Müşteri Adı Soyadı" type="text" value={this.state.filterMemberCustomerFullName}/>
                <strong>Başvuru Sahibi No</strong>
                <input className="form-control form-input mb-2 mt-1" onChange={event => this.setState({filterMemberId: event.target.value})} onKeyDown={this.handleKeyPress} placeholder="Başvuru Sahibi No" type="text" value={this.state.filterMemberId}/>
                <strong>Başvuru Sahibi</strong>
                <input className="form-control form-input mb-2 mt-1" onChange={event => this.setState({filterFullName: event.target.value})} onKeyDown={this.handleKeyPress} placeholder="Başvuru Sahibi" type="text" value={this.state.filterFullName}/>
                <strong>Ödeme Başlangıç Tarihi</strong>
                <input className="form-control form-input mb-2 mt-1" onChange={event => this.setState({filterPaymentStartDate: event.target.value})} onKeyDown={this.handleKeyPress} type="date" value={this.state.filterPaymentStartDate} />
                <strong>Ödeme Bitiş Tarihi</strong>
                <input className="form-control form-input mb-2 mt-1" onChange={event => this.setState({filterPaymentEndDate: event.target.value})} onKeyDown={this.handleKeyPress} type="date" value={this.state.filterPaymentEndDate} />
                <strong>Ödeme Durumu</strong>
                <select className="form-control form-input mb-2 mt-1" onChange={this.filterPaymentStatus} onKeyDown={this.handleKeyPress} value={this.state.filterPaymentStatus}>
                  <option value="">Seçiniz</option>
                  <option value="1">İşleme Alındı</option>
                  <option value="2">Başarılı</option>
                  <option value="3">Başarısız</option>
                </select>
                <strong>Onaylandı</strong>
                <select className="form-control form-input mb-2 mt-1" onChange={event => this.setState({isApproved: event.target.value})} onKeyDown={this.handleKeyPress} value={this.state.isApproved}>
                  <option value="">Seçiniz</option>
                  <option value="1">Evet</option>
                  <option value="0">Hayır</option>
                </select>
                <strong>Transfer Edildi</strong>
                <select className="form-control form-input mb-2 mt-1" onChange={event => this.setState({isTransferred: event.target.value})} onKeyDown={this.handleKeyPress} value={this.state.isTransferred}>
                  <option value="">Seçiniz</option>
                  <option value="1">Evet</option>
                  <option value="0">Hayır</option>
                </select>
                <strong>İptal Edildi</strong>
                <select className="form-control form-input mb-2 mt-1" onChange={event => this.setState({isCancelled: event.target.value})} onKeyDown={this.handleKeyPress} value={this.state.isCancelled}>
                  <option value="">Seçiniz</option>
                  <option value="1">Evet</option>
                  <option value="0">Hayır</option>
                </select>
                <div className="d-flex justify-content-end">
                  <button className="btn btn-orange mt-3 mr-2"><i className="fa fa-refresh" onClick={this.resetOnClick}></i> Sıfırla</button>
                  <button className="btn btn-orange mt-3" ><i className="fa fa-filter"  onClick={this.filterOnClick}></i> Filtrele</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-3 order-first order-xl-last d-none d-xl-block">
          <div className="ibox">
            <div className="ibox-title text-darkblue">
              <h5><i className="fa fa-filter"></i> Filtrele</h5>
            </div>
            <div className="ibox-content text-darkblue">
              <strong>Kredi No</strong>
              <input className="form-control form-input mb-2 mt-1" onChange={event => this.setState({filterId: event.target.value})} onKeyDown={this.handleKeyPress} placeholder="Kredi No" type="text" value={this.state.filterId}/>
              <strong>Ödeme Kodu</strong>
              <input className="form-control form-input mb-2 mt-1" onChange={event => this.setState({filterPaymentHash: event.target.value})} onKeyDown={this.handleKeyPress} placeholder="Ödeme Kodu" type="text" value={this.state.filterPaymentHash}/>
              <strong>Sağlayıcı</strong>
              <select className="form-control form-input mb-2 mt-1" onChange={this.filterProvider} onKeyDown={this.handleKeyPress} value={this.state.filterCreditCardProviderId}>
                <option value="">Seçiniz</option>
                {this.state.creditcardProviders.map(provider =>
                <option value={provider.id}>{provider.name}</option>
                )}
              </select>
              <strong>İlan No</strong>
              <input className="form-control form-input mb-2 mt-1" onChange={event => this.setState({filterAdvertId: event.target.value})} onKeyDown={this.handleKeyPress} placeholder="İlan No" type="text" value={this.state.filterAdvertId}/>
              <strong>Kart Sahibi</strong>
              <input className="form-control form-input mb-2 mt-1" onChange={event => this.setState({filterCardHolderName: event.target.value})} onKeyDown={this.handleKeyPress} placeholder="Kart Sahibi" type="text" value={this.state.filterCardHolderName}/>
              <strong>Müşteri Adı Soyadı</strong>
              <input className="form-control form-input mb-2 mt-1" onChange={event => this.setState({filterMemberCustomerFullName: event.target.value})} onKeyDown={this.handleKeyPress} placeholder="Müşteri Adı Soyadı" type="text" value={this.state.filterMemberCustomerFullName}/>
              <strong>Başvuru Sahibi No</strong>
              <input className="form-control form-input mb-2 mt-1" onChange={event => this.setState({filterMemberId: event.target.value})} onKeyDown={this.handleKeyPress} placeholder="Başvuru Sahibi No" type="text" value={this.state.filterMemberId}/>
              <strong>Başvuru Sahibi</strong>
              <input className="form-control form-input mb-2 mt-1" onChange={event => this.setState({filterFullName: event.target.value})} onKeyDown={this.handleKeyPress} placeholder="Başvuru Sahibi" type="text" value={this.state.filterFullName}/>
              <strong>Ödeme Başlangıç Tarihi</strong>
              <input className="form-control form-input mb-2 mt-1" onChange={event => this.setState({filterPaymentStartDate: event.target.value})} onKeyDown={this.handleKeyPress} type="date" value={this.state.filterPaymentStartDate} />
              <strong>Ödeme Bitiş Tarihi</strong>
              <input className="form-control form-input mb-2 mt-1" onChange={event => this.setState({filterPaymentEndDate: event.target.value})} onKeyDown={this.handleKeyPress} type="date" value={this.state.filterPaymentEndDate} />
              <strong>Ödeme Durumu</strong>
              <select className="form-control form-input mb-2 mt-1" onChange={this.filterPaymentStatus} onKeyDown={this.handleKeyPress} value={this.state.filterPaymentStatus}>
                <option value="">Seçiniz</option>
                  <option value="1">İşleme Alındı</option>
                  <option value="2">Başarılı</option>
                  <option value="3">Başarısız</option>
              </select>
              <strong>Onaylandı</strong>
              <select className="form-control form-input mb-2 mt-1" onChange={event => this.setState({isApproved: event.target.value})} onKeyDown={this.handleKeyPress} value={this.state.isApproved}>
                <option value="">Seçiniz</option>
                <option value="1">Evet</option>
                <option value="0">Hayır</option>
              </select>
              <strong>Transfer Edildi</strong>
              <select className="form-control form-input mb-2 mt-1" onChange={event => this.setState({isTransferred: event.target.value})} onKeyDown={this.handleKeyPress} value={this.state.isTransferred}>
                <option value="">Seçiniz</option>
                <option value="1">Evet</option>
                <option value="0">Hayır</option>
              </select>
              <strong>İptal Edildi</strong>
              <select className="form-control form-input mb-2 mt-1" onChange={event => this.setState({isCancelled: event.target.value})} onKeyDown={this.handleKeyPress} value={this.state.isCancelled}>
                <option value="">Seçiniz</option>
                <option value="1">Evet</option>
                <option value="0">Hayır</option>
              </select>
              <div className="d-flex justify-content-end">
                <button className="btn btn-orange mt-3 mr-2" onClick={this.resetOnClick}><i className="fa fa-refresh"></i> Sıfırla</button>
                <button className="btn btn-orange mt-3"  onClick={this.filterOnClick}><i className="fa fa-filter"></i> Filtrele</button>
              </div>
            </div>
          </div>
        </div>
      </div>
  }
}

export default function CreditCardRequests(props) {
  return (
    <CreditCardRequestsModule navigate={useNavigate()} />
  )
}